// Marketing Budget Tablo Konfigürasyonları
export const tableConfigs = {
  'ilan_reklam': {
    title: 'İlan Reklam Raporu',
    apiEndpoint: '/marketing-budget/pivot-advert/',
    pivotConfig: {
      rows: ['market_name'],           // Satırlar: Pazarlar
      columns: ['subgroup_name'],      // Sütunlar: Alt gruplar
      values: 'budget_amount'          // Değerler: Bütçe miktarı
    },
    filters: ['budget_year', 'budget_month'],
    colors: {
      header: 'bg-blue-100 dark:bg-blue-900/20',
      total: 'bg-blue-200 dark:bg-blue-800/30'
    }
  },
  
  'fuar_detay': {
    title: 'Fuar Detay Raporu',
    apiEndpoint: '/marketing-budget/pivot-fair/',
    pivotConfig: {
      rows: ['market_name'],         // Satırlar: Pazarlar
      columns: ['subgroup_name'],     // Sütunlar: Alt gruplar
      values: 'budget_amount',        // Değerler: Bütçe miktarı
      displayMode: 'fair_detail_table'
    },
    filters: ['budget_year', 'budget_month'],
    colors: {
      header: 'bg-green-100 dark:bg-green-900/20',
      total: 'bg-green-200 dark:bg-green-800/30'
    }
  },
  
  'promosyon': {
    title: 'Promosyon Raporu',
    apiEndpoint: '/marketing-budget/pivot-promotion/',
    pivotConfig: {
      rows: ['market_name'],         // Satırlar: Pazarlar
      columns: ['subgroup_name'],     // Sütunlar: Alt gruplar
      values: 'budget_amount',        // Değerler: Bütçe miktarı
      // Promosyon özel tablo görünümü için
      displayMode: 'promotion_table',   // Promosyon özel tablo
      tableColumns: [
        'market_name', 'country', 'city', 'agency', 'quantity',
        'vize', 'kargo', 'otel', 'ulaşım', 'extra', 'harcirah', 'stand'
      ]
    },
    filters: ['budget_year', 'budget_month'],
    colors: {
      header: 'bg-purple-100 dark:bg-purple-900/20',
      total: 'bg-purple-200 dark:bg-purple-800/30'
    }
  },
  
  'workshop': {
    title: 'Workshop Raporu',
    apiEndpoint: '/marketing-budget/pivot-workshop/',
    pivotConfig: {
      rows: ['market_name'],         // Satırlar: Pazarlar
      columns: ['subgroup_name'],     // Sütunlar: Alt gruplar
      values: 'budget_amount',        // Değerler: Bütçe miktarı
      displayMode: 'workshop_table'
    },
    filters: ['budget_year', 'budget_month'],
    colors: {
      header: 'bg-orange-100 dark:bg-orange-900/20',
      total: 'bg-orange-200 dark:bg-orange-800/30'
    }
  },
  
      'sales_call': {
        title: '2025 SALES CALL PLAN',
        apiEndpoint: '/marketing-budget/pivot-salescall/',
        pivotConfig: {
          rows: ['market_name'],         // Satırlar: Pazarlar
          columns: ['subgroup_name'],     // Sütunlar: Alt gruplar
          values: 'budget_amount',        // Değerler: Bütçe miktarı
          // Sales Call özel tablo görünümü için
          displayMode: 'sales_call_table'   // Sales Call özel tablo
        },
        filters: ['budget_year', 'budget_month'],
        colors: {
          header: 'bg-red-100 dark:bg-red-900/20',
          total: 'bg-red-200 dark:bg-red-800/30'
        }
      },
      'christmas_gift': {
        title: 'YILBAŞI HEDİYE PLANI',
        apiEndpoint: '/marketing-budget/pivot-christmasgift/',
        pivotConfig: {
          rows: ['market_name'],         // Satırlar: Pazarlar
          columns: ['subgroup_name'],     // Sütunlar: Alt gruplar
          values: 'budget_amount',        // Değerler: Bütçe miktarı
          // Yılbaşı Hediye özel tablo görünümü için
          displayMode: 'christmas_gift_table'   // Yılbaşı Hediye özel tablo
        },
        filters: ['budget_year', 'budget_month'],
        colors: {
          header: 'bg-green-100 dark:bg-green-900/20',
          total: 'bg-green-200 dark:bg-green-800/30'
        }
      },
      'web_software': {
        title: 'WEB YAZILIM PLANI',
        apiEndpoint: '/marketing-budget/pivot-websoftware/',
        pivotConfig: {
          rows: ['subgroup_name'],       // Satırlar: Alt gruplar
          columns: ['budgettype_name'],  // Sütunlar: Bütçe tipleri
          values: 'budget_amount',        // Değerler: Bütçe miktarı
          // Web Yazılım özel tablo görünümü için
          displayMode: 'web_software_table'   // Web Yazılım özel tablo
        },
        filters: ['budget_year', 'budget_month'],
        colors: {
          header: 'bg-blue-100 dark:bg-blue-900/20',
          total: 'bg-blue-200 dark:bg-blue-800/30'
        }
      },
      'repres': {
        title: 'YURTDIŞI TEMSİLCİ PLANI',
        apiEndpoint: '/marketing-budget/pivot-repres/',
        pivotConfig: {
          rows: ['market_name'],         // Satırlar: Pazarlar
          columns: ['subgroup_name'],     // Sütunlar: Alt gruplar
          values: 'budget_amount'         // Değerler: Bütçe miktarı
        },
        filters: ['budget_year', 'budget_month'],
        colors: {
          header: 'bg-indigo-100 dark:bg-indigo-900/20',
          total: 'bg-indigo-200 dark:bg-indigo-800/30'
        }
      },
      'represhos': {
        title: 'TEMSİL AĞIRLAMA PLANI',
        apiEndpoint: '/marketing-budget/pivot-represhos/',
        pivotConfig: {
          rows: ['subgroup_name'],        // Satırlar: Alt gruplar
          columns: ['budget_month'],      // Sütunlar: Aylar
          values: 'budget_amount',        // Değerler: Bütçe miktarı
          groupBy: 'hotel_name',          // Otel adına göre gruplama
          displayMode: 'represhos_table'  // Özel tablo modu
        },
        filters: ['budget_year', 'budget_month'],
        colors: {
          header: 'bg-teal-100 dark:bg-teal-900/20',
          total: 'bg-teal-200 dark:bg-teal-800/30'
        }
      },
      'digital_month': {
        title: 'DİJİTAL PAZARLAMA AY BAZLI',
        apiEndpoint: '/marketing-budget/pivot-digitalmonth/',
        pivotConfig: {
          rows: ['eur_curr'],             // Satırlar: Euro Kur + Aylar
          columns: ['subgroup_name'],     // Sütunlar: Alt gruplar
          values: 'budget_amount',        // Değerler: Bütçe miktarı (Euro)
          groupBy: 'region',              // Bölgeye göre gruplama
          displayMode: 'digital_month_table',  // Özel tablo modu
          additionalRow: 'budget_month'   // Ay bilgisi satırda yer alacak
        },
        filters: ['budget_year', 'budget_month'],
        colors: {
          header: 'bg-cyan-100 dark:bg-cyan-900/20',
          total: 'bg-cyan-200 dark:bg-cyan-800/30'
        }
      }
};

// Tablo seçenekleri
export const tableOptions = [
  { value: 'ilan_reklam', label: 'İlan Reklam' },
  { value: 'fuar_detay', label: 'Fuar Detay' },
  { value: 'promosyon', label: 'Promosyon' },
  { value: 'workshop', label: 'Workshop' },
  { value: 'sales_call', label: 'Sales Call' },
  { value: 'christmas_gift', label: 'Yılbaşı Hediye' },
  { value: 'web_software', label: 'Web Yazılım' },
  { value: 'repres', label: 'Yurtdışı Temsilci' },
  { value: 'represhos', label: 'Temsil Ağırlama' },
  { value: 'digital_month', label: 'Dijital Pazarlama Ay Bazlı' }
];
